var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MulReportHeader',{attrs:{"dataFrom":_vm.table.params,"loading":_vm.loading,"toPdf":_vm.eleToPdf},on:{"search":_vm.searchData}}),_c('Table',{ref:"tableRef",staticStyle:{"margin-top":"12px"},attrs:{"border":"","columns":_vm.table.columns,"data":_vm.table.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }